export default __webpack_public_path__ + "static/media/adviceStartup.386ea377.png";